import { isTaskUuid } from "@/components/tasks/taskIndexRecords";

/** Query aliases are retained for notifications already stored in the inbox. */
export function taskLinkIntent(search: string, recordId?: string) {
  const params = new URLSearchParams(search);
  const rawId = recordId ?? params.get("taskId") ?? params.get("id");
  const rawOrg = params.get("organizationId") ?? params.get("org");
  return {
    hasTarget: rawId !== null && rawId !== undefined,
    taskId: isTaskUuid(rawId) ? rawId.toLowerCase() : null,
    organizationId: isTaskUuid(rawOrg) ? rawOrg.toLowerCase() : null,
    invalidOrganization: rawOrg !== null && !isTaskUuid(rawOrg),
  };
}

export function taskNotificationHref(taskId: string, organizationId: string) {
  return `/tasks?${new URLSearchParams({ taskId, organizationId })}`;
}

/** Restore the tenant intent absent from older stored task URLs at every inbox surface. */
export function notificationHref(notification: { link_url: string | null; organization_id: string }) {
  const href = notification.link_url;
  if (!href || !/^\/tasks(?:[/?#]|$)/.test(href)) return href;
  const url = new URL(href, "https://forge.invalid");
  if (!url.searchParams.has("organizationId") && !url.searchParams.has("org")) {
    url.searchParams.set("organizationId", notification.organization_id);
  }
  return `${url.pathname}${url.search}${url.hash}`;
}
